import axios from 'axios';
import { Floor } from '../interfaces/api/floor';

export interface FloorSearchFilterParam {
	search?: string;
	building?: string;
	building__organization?: string;
}

function queryBuilderSearchFilter(params: FloorSearchFilterParam): URLSearchParams {
	const queryParams = new URLSearchParams();
	if (params.search) {
		queryParams.append('search', params.search);
	}
	if (params.building) {
		queryParams.append('building', params.building);
	}
	if (params.building__organization) {
		queryParams.append('building__organization', params.building__organization);
	}
	return queryParams;
}

export async function getFloors(): Promise<Floor[]> {
	try {
		const response = await axios.get<Floor[]>('api/floors/');
		return response.data;
	} catch (error) {
		if (axios.isAxiosError(error)) {
			throw error.response;
		}
		throw error;
	}
}

export async function getFloor(id: number): Promise<Floor> {
	try {
		const response = await axios.get<Floor>(`api/floors/${id}/`);
		return response.data;
	} catch (error) {
		if (axios.isAxiosError(error)) {
			throw error.response;
		}
		throw error;
	}
}

export async function getFloorsSearchFilter(params: FloorSearchFilterParam): Promise<Floor[]> {
	try {
		const queryParams = queryBuilderSearchFilter(params);
		const response = await axios.get<Floor[]>(`api/floors/`, {
			params: queryParams,
		});
		return response.data;
	} catch (error) {
		if (axios.isAxiosError(error)) {
			throw error.response;
		}
		throw error;
	}
}
